import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ExternalIdProviderFormComponent } from 'pages/external-id-provider-form/external-id-provider-form.component';
import { GoogleIdProviderComponent } from 'pages/external-id-provider-form/google/google-id-provider.component';
import { CertemyCommonModule } from 'common/certemy-common.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: ExternalIdProviderFormComponent,
      },
    ]),
  ],
  declarations: [ExternalIdProviderFormComponent, GoogleIdProviderComponent],
})
export class ExternalIdProviderFormModule {}
